import { mount } from 'svelte';
import './styles/tokens.css';
import './sentry';
import App from './App.svelte';
import { theme } from './theme-state.svelte.js';

theme.init();

// Mark this device as having seen the calculator → landing page auto-redirects on next visit.
try { localStorage.setItem('divcalc:seen_calc', '1'); } catch { /* ignore */ }

const target = document.getElementById('app');
if (!target) throw new Error('#app not found');

// Clear boot skeleton (CLS placeholder from index.html) — Svelte 5 mount()
// appends rather than replaces children, so skeleton would stay overlaid.
target.innerHTML = '';

const app = mount(App, { target });

export default app;
